module.exports = __webpack_public_path__ + "img/customer-satisfaction.52df16fd.jpg";